import { ENDPOINTS_EMPLOYEE } from 'common/endpoints/vacations-absences.endpoints';

class VacationScheduleEndDate {

  constructor($http, $log) {
    'ngInject';
    this.http = $http;
    this.$log = $log;
  }

  get() {
    return this.http.get(ENDPOINTS_EMPLOYEE.get.vacationScheduleEndDate)
      .then((response) => response.data);
  }
}

export default VacationScheduleEndDate;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/myVacations/vacationScheduleEndDate.service.js